// Define the base scale according to Major Third
// See: https://type-scale.com/
const baseScale = 0.512;
// The factor used to increment each step of the scale with
const scaleRatio = 1.25;
/**
 * Multiplies the scale on the previously accumulated value, starting at the base scale
 * @param n is the number of times to increase the baseScale with the scaleRatio
 * @param r is a boolean that, if true, reverses the scaleRatio
 */
const modularScale = (n, r = false) => parseFloat([...Array(n - 1)].reduce((acc) => acc * (r ? 1 / scaleRatio : scaleRatio), baseScale).toFixed(3));
// The global spacing in rem's. By tweaking this you will increase or decrease spacing
// between all components that use the ${padding.()} and ${margin.()} mixins
export const globalSpacing = 1;
// Scales are the same between themes
export const scales = {
    none: 0,
    tiny: modularScale(2, true),
    smaller: modularScale(2),
    small: modularScale(3),
    normal: modularScale(4),
    medium: modularScale(5),
    large: modularScale(6),
    larger: modularScale(7),
    huge: modularScale(8), // 2.441
};
//# sourceMappingURL=spacing.js.map